<template>
  <div
    ref="wrapperRef"
    class="edit-history"
  >
    <v-btn
      variant="outlined"
      size="small"
      class="bg-white"
      @click="toggle"
    >
      {{ buttonLabel }}
    </v-btn>
    <teleport to="body">
      <div
        v-if="isOpen"
        class="edit-history__popover"
        :style="{ top: `${popoverTop}px`, left: `${popoverLeft}px`, minWidth: `${popoverWidth}px` }"
      >
        <div class="edit-history__header">
          {{ buttonLabel }}
        </div>
        <div
          v-if="sortedHistory.length === 0"
          class="edit-history__empty"
        >
          {{ emptyText }}
        </div>
        <div
          v-for="(entry, index) in sortedHistory"
          :key="index"
          class="edit-history__entry"
        >
          <div class="edit-history__meta">
            <span class="edit-history__editor">{{ entry.editor }}</span>
            <span class="edit-history__datetime">{{ entry.editedAt }}</span>
          </div>
          <div class="edit-history__content">
            {{ entry.content }}
          </div>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
export default {
  name: "EditHistoryPopover",
  props: {
    history: {
      type: Array,
      default: () => []
    },
    buttonLabel: {
      type: String,
      default: "編集履歴"
    },
    emptyText: {
      type: String,
      default: "編集履歴はありません"
    },
    popoverWidth: {
      type: Number,
      default: 350
    }
  },
  data() {
    return {
      isOpen: false,
      popoverTop: 0,
      popoverLeft: 0
    };
  },
  computed: {
    // editedAt は "YYYY/MM/DD HH:mm" 形式（ゼロパディング済み）のため、
    // Date parseに頼らず文字列比較で安全に降順ソートできる
    // （new Date("2026/01/01 10:00") はブラウザ実装差、特にSafariでNaNになり得るため使わない）。
    sortedHistory() {
      return [...this.history].sort(
        (a, b) => (b.editedAt || "").localeCompare(a.editedAt || "")
      );
    }
  },
  mounted() {
    document.addEventListener("click", this.handleDocumentClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
  methods: {
    toggle() {
      if (this.isOpen) {
        this.isOpen = false;
        return;
      }

      this.$nextTick(() => {
        const button = this.$refs.wrapperRef?.querySelector("button");
        if (button) {
          const rect = button.getBoundingClientRect();
          this.popoverTop = rect.bottom + 4;
          this.popoverLeft = rect.right - this.popoverWidth;
        }
        this.isOpen = true;
      });
    },
    handleDocumentClick(event) {
      if (!this.isOpen) return;

      const wrapper = this.$refs.wrapperRef;
      if (wrapper && !wrapper.contains(event.target)) {
        this.isOpen = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-history {
  position: relative;
}
</style>

<style lang="scss">
.edit-history__popover {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 320px;
  max-width: 400px;
  overflow-y: auto;
  position: fixed;
  z-index: 9999;
}

.edit-history__header {
  background: #f8f8f8;
  border-bottom: 1px solid #e0e0e0;
  font-size: 0.9rem;
  font-weight: 700;
  padding: 10px 12px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.edit-history__empty {
  color: #999;
  font-size: 0.85rem;
  padding: 16px 12px;
  text-align: center;
}

.edit-history__entry {
  border-bottom: 1px solid #f0f0f0;
  padding: 10px 12px;

  &:last-child {
    border-bottom: none;
  }
}

.edit-history__meta {
  display: flex;
  font-size: 0.75rem;
  gap: 12px;
  margin-bottom: 6px;
}

.edit-history__editor {
  color: #3acac9;
  font-weight: 700;
}

.edit-history__datetime {
  color: #999;
}

.edit-history__content {
  color: #333;
  font-size: 0.85rem;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
